<div class="ng-selector-container">
  <ng-container *ngIf="!formControl?.pending; else pendingTmpl">
    <ng-select
      #selectModel="ngModel"
      [items]="items"
      bindLabel="name"
      (change)="onChangeLocal($event)"
      [id]="id"
      [searchable]="true"
      [(ngModel)]="value"
      [readonly]="readonly"
      [disabled]="disabled"
      [selectOnTab]="isCross"
      [ngClass]="{
        'ng-read-only': readonly,
        'ng-touched': formControl?.touched
      }"
      [multiple]="multiSelect"
      [closeOnSelect]="closeOnSelect"
      [clearSearchOnAdd]="true"
      (blur)="onElemBlur()"
      (focus)="onElemFocus()"
      appendTo="body"
      [labelForId]="id"
      [placeholder]="placeholder"
      groupBy="group"
    >
      <ng-container *ngIf="multiSelect; else singleSelect">
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div class="ng-values">
            <ng-container *ngFor="let item of items; let i = index">
              {{ item.name }}{{ i === items.length - 1 ? '' : ', ' }}
            </ng-container>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #singleSelect ng-label-tmp let-item="item" let-clear="clear">
        <span
          [ngStyle]="{
            color: textColor ? textColor : ['inherit']
          }"
          class="temp-label"
        >
          {{ value }}</span
        >
        <span class="additional-info">{{ info }}</span>
      </ng-template>
    </ng-select>
  </ng-container>
  <ng-template #pendingTmpl>
    <div class="ng-selector-container__spinner-container">
      <span class="spinner spinner-sm spinner-inverse"> </span>
    </div>
  </ng-template>
</div>
